(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      this.scrollEl = this.querySelector('[data-ct-scroll]');
      this.stage = this.querySelector('.comparison-table__stage');
      this.prev = this.querySelector('[data-ct-prev]');
      this.next = this.querySelector('[data-ct-next]');

      this.resizeObserver = new ResizeObserver(() => this.syncLayout());
      if (this.stage) this.resizeObserver.observe(this.stage);
      if (this.scrollEl) {
        this.resizeObserver.observe(this.scrollEl);
        this.scrollEl.addEventListener('scroll', () => this.syncControls(), { passive: true });
      }
      this.prev?.addEventListener('click', () => this.nudge(-1));
      this.next?.addEventListener('click', () => this.nudge(1));
      this.syncLayout();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    syncLayout() {
      this.lockStickyColumns();
      this.paintHighlight();
      this.syncControls();
    }

    lockStickyColumns() {
      const row = this.querySelector('.comparison-table__row');
      if (!row) return;

      const fixedCount = Math.max(1, Math.min(4, Number(this.dataset.fixedColumns || 2)));
      let left = 0;

      for (let index = 1; index <= fixedCount; index++) {
        const cell = row.children[index - 1];
        if (!cell) break;

        const width = Math.round(cell.getBoundingClientRect().width);
        this.style.setProperty(`--ct-sticky-left-${index}`, `${left}px`);
        if (index === 1) {
          this.style.setProperty('--ct-col1-width', `${width}px`);
        }
        left += width;
      }
    }

    paintHighlight() {
      const cells = this.querySelectorAll(
        '.comparison-table__cell--header-highlight, .comparison-table__cell--highlight'
      );
      if (!cells.length) return;

      const firstBox = cells[0].getBoundingClientRect();
      const lastBox = cells[cells.length - 1].getBoundingClientRect();
      const height = Math.max(lastBox.bottom - firstBox.top, 1);

      cells.forEach((cell) => {
        const box = cell.getBoundingClientRect();
        cell.style.setProperty('--ct-hl-size', `${height}px`);
        cell.style.setProperty('--ct-hl-shift', `${firstBox.top - box.top}px`);
      });
    }

    columnWidth() {
      const cell = this.querySelector(
        '.comparison-table__row > :nth-child(3), .comparison-table__row > :nth-child(2)'
      );
      return cell ? cell.getBoundingClientRect().width : 80;
    }

    nudge(direction) {
      if (!this.scrollEl) return;
      this.scrollEl.scrollBy({ left: direction * this.columnWidth(), behavior: 'smooth' });
    }

    syncControls() {
      if (!this.scrollEl || !this.prev || !this.next) return;
      const max = this.scrollEl.scrollWidth - this.scrollEl.clientWidth - 2;
      this.prev.disabled = this.scrollEl.scrollLeft <= 2;
      this.next.disabled = this.scrollEl.scrollLeft >= max;
    }
  }

  if (!customElements.get('comparison-table')) {
    customElements.define('comparison-table', ComparisonTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mq = window.matchMedia('(max-width: 749px)');

    const sync = (el) => {
      const speed = el.getAttribute('data-mobile-autoplay');
      if (!speed) return;

      if (mq.matches) {
        el.setAttribute('autoplay', speed);
        if (typeof el.play === 'function') el.play();
      } else {
        el.removeAttribute('autoplay');
        if (typeof el.pause === 'function') el.pause();
      }
    };

    const init = () => {
      document.querySelectorAll('slideshow-component[data-mobile-autoplay]').forEach((el) => {
        sync(el);
      });
    };

    mq.addEventListener('change', init);
    document.addEventListener('shopify:section:load', init);

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slideshow-component').then(init);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function patchIframe(iframe) {
      if (!iframe || !iframe.src || iframe.src.indexOf('wistia') === -1) return;

      try {
        var url = new URL(iframe.src);
        if (url.searchParams.get('videoFoam') === 'false' && url.searchParams.get('fitStrategy') === 'cover') {
          return;
        }

        url.searchParams.set('videoFoam', 'false');
        url.searchParams.set('fitStrategy', 'cover');
        iframe.src = url.toString();
      } catch (error) {}
    }

    function patchRoot(root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll('.customer-reviews__custom-liquid iframe').forEach(patchIframe);
      root.querySelectorAll('.customer-reviews__custom-liquid wistia-player').forEach(function (player) {
        player.setAttribute('fit-strategy', 'cover');
      });
    }

    function patchAll() {
      document.querySelectorAll('.customer-reviews').forEach(patchRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', patchAll);
    } else {
      patchAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      patchRoot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-marquee"] && !Shopify.designMode) return;
  try {
    
  class TrustMarquee extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.trust-marquee__viewport');
      this.group = this.querySelector('.trust-marquee__group:not(.trust-marquee__copy)');

      if (!this.viewport || !this.group) return;

      this.resizeObserver = new ResizeObserver(() => this.#syncOverflow());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);

      for (const item of this.group.children) {
        this.resizeObserver.observe(item);
      }
      this.#syncOverflow();

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this.#syncOverflow());
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    #syncOverflow() {
      if (!this.viewport || !this.group) return;

      const styles = getComputedStyle(this.group);
      const gap = Number.parseFloat(styles.gap) || 0;
      const items = this.group.children;
      let contentWidth = 0;

      for (let index = 0; index < items.length; index++) {
        contentWidth += items[index].getBoundingClientRect().width;
        if (index < items.length - 1) contentWidth += gap;
      }

      const overflowing = contentWidth > this.viewport.clientWidth + 1;
      this.classList.toggle('trust-marquee--overflowing', overflowing);
    }
  }

  if (!customElements.get('trust-marquee')) {
    customElements.define('trust-marquee', TrustMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
